{
  "login": {
    "errors": {
      "unexpected": "No fue posible continuar ahora. Inténtalo de nuevo.",
      "additionalVerification": "Se necesita una verificación adicional",
      "invalidCredentials": "Código o contraseña no válidos",
      "sendCode": "Error al enviar el código"
    },
    "email": {
      "title": "¡Bienvenido de nuevo!",
      "subtitle": "Ingresa tu email para acceder a la plataforma",
      "label": "Email",
      "placeholder": "tu@email.com",
      "continue": "Continuar",
      "forgotPassword": "¿Olvidaste tu contraseña?"
    },
    "verify": {
      "title": "Verificación de seguridad",
      "subtitle": "Elige un método para confirmar tu identidad",
      "password": {
        "title": "Contraseña",
        "description": "Ingresa tu contraseña de acceso",
        "submit": "Entrar"
      },
      "emailCode": {
        "title": "Código por email",
        "description": "Recibe un código de 6 dígitos en tu email",
        "send": "Enviar código a {{email}}",
        "sentTo": "Código enviado a <email>{{email}}</email>",
        "submit": "Verificar",
        "resendIn": "Reenviar en {{seconds}} s",
        "sending": "Enviando...",
        "resend": "Reenviar código"
      },
      "sms": {
        "title": "Código por SMS",
        "description": "Verificación por celular",
        "comingSoon": "Próximamente"
      },
      "back": "Volver"
    }
  },
  "forgotPassword": {
    "validation": {
      "invalidEmail": "Email no válido"
    },
    "errors": {
      "send": "Error al enviar el email"
    },
    "success": {
      "title": "¡Email enviado!",
      "description": "Si el email existe en nuestra base de datos, recibirás un enlace de recuperación."
    },
    "backToLogin": "Volver al inicio de sesión",
    "title": "Recuperar contraseña",
    "subtitle": "Ingresa tu email para recibir un enlace de recuperación",
    "emailLabel": "Email",
    "emailPlaceholder": "tu@email.com",
    "submit": "Enviar enlace"
  },
  "resetPassword": {
    "validation": {
      "minLength": "La contraseña debe tener al menos 8 caracteres",
      "complexity": "Debe contener mayúscula, minúscula y número",
      "mismatch": "Las contraseñas no coinciden"
    },
    "invalid": {
      "title": "Enlace no válido",
      "description": "El enlace de recuperación no es válido o expiró.",
      "requestNew": "Solicitar un nuevo enlace"
    },
    "success": {
      "title": "¡Contraseña cambiada!",
      "description": "Tu contraseña se ha restablecido correctamente. Inicia sesión con la nueva contraseña.",
      "goToLogin": "Ir al inicio de sesión"
    },
    "toast": {
      "success": "¡Contraseña cambiada correctamente!"
    },
    "errors": {
      "reset": "Error al restablecer la contraseña. Es posible que el enlace haya expirado."
    },
    "title": "Nueva contraseña",
    "subtitle": "Ingresa tu nueva contraseña a continuación",
    "passwordLabel": "Nueva contraseña",
    "passwordPlaceholder": "Mínimo 8 caracteres",
    "confirmLabel": "Confirmar contraseña",
    "confirmPlaceholder": "Repite la contraseña",
    "submitting": "Restableciendo...",
    "submit": "Restablecer contraseña",
    "backToLogin": "Volver al inicio de sesión"
  },
  "platformRoot": {
    "title": "Área de miembros para quienes enseñan",
    "description": "Llegaste a Xtreed. Si eres alumno, entra desde la dirección que te envió tu escuela: cada área de miembros tiene la suya.",
    "devShortcuts": "Atajos de desarrollo"
  },
  "deepLink": {
    "errors": {
      "incompleteLink": "El enlace de acceso está incompleto o mal formado. Pide al administrador que genere un nuevo enlace.",
      "validateFailed": "No se pudo validar el enlace de acceso."
    },
    "footer": "¿Problemas con el acceso? <link>Ir al inicio de sesión tradicional</link>",
    "verifying": {
      "title": "Verificando acceso",
      "description": "Estamos validando tu enlace seguro. Solo tardará un momento.",
      "steps": {
        "token": {
          "title": "Validando token",
          "subtitle": "Comprobando firma y caducidad"
        },
        "auth": {
          "title": "Autenticando usuario",
          "subtitle": "Creando sesión segura"
        },
        "redirect": {
          "title": "Redirigiendo",
          "subtitle": "Llevándote a la plataforma"
        }
      },
      "doNotClose": "No cierres esta pestaña durante la verificación"
    },
    "success": {
      "welcome": "¡Bienvenido, {{name}}!",
      "granted": "¡Acceso concedido!",
      "description": "Autenticación completada correctamente. Te estamos llevando a la plataforma…",
      "redirecting": "Redirigiendo"
    },
    "error": {
      "title": "No se pudo iniciar sesión",
      "fallback": "Hubo un problema al validar tu enlace de acceso. Inténtalo de nuevo.",
      "reasonsTitle": "Motivos más comunes",
      "reasons": {
        "used": "El enlace ya se ha utilizado (uso único)",
        "expired": "El enlace expiró (válido durante 24 horas)",
        "modified": "El enlace se ha modificado o está incompleto"
      },
      "retry": "Intentar de nuevo",
      "goToLogin": "Ir al inicio de sesión"
    }
  },
  "devflixAuthorize": {
    "errors": {
      "incompleteRequest": "La solicitud de DevFlix está incompleta. Vuelve e inténtalo de nuevo.",
      "authorizeFailed": "No se pudo autorizar DevFlix. Confirma tu acceso e inténtalo de nuevo."
    },
    "title": {
      "unauthorized": "Acceso no autorizado",
      "opening": "Abriendo tu DevFlix"
    },
    "confirming": "Confirmando tu cuenta y tus accesos de forma segura…"
  },
  "terms": {
    "toast": {
      "success": "¡Términos aceptados correctamente!",
      "error": "Error al guardar la aceptación de los términos. Inténtalo de nuevo."
    },
    "header": "Términos de uso",
    "title": "Términos y condiciones de uso",
    "subtitle": "Para seguir usando la plataforma, lee y acepta los términos a continuación.",
    "iframeTitle": "Términos y condiciones",
    "agree": "He leído y acepto los <bold>Términos y condiciones de uso</bold> de {{name}}.",
    "auditInfo": "Al aceptar, se registrarán tu dirección IP y tu ubicación aproximada con fines de auditoría. El navegador te pedirá permiso para acceder a tu ubicación.",
    "submitting": "Registrando aceptación...",
    "submit": "Aceptar y continuar"
  },
  "magicLink": {
    "validation": {
      "invalidEmail": "Email no válido"
    },
    "errors": {
      "send": "Error al enviar el enlace mágico"
    },
    "sent": {
      "title": "¡Enlace enviado!",
      "description": "Enviamos un enlace de acceso a <email>{{email}}</email>",
      "nextSteps": "Próximos pasos:",
      "steps": {
        "inbox": "Revisa tu bandeja de entrada",
        "click": "Haz clic en el enlace recibido",
        "auto": "Se iniciará tu sesión automáticamente"
      },
      "notReceived": "¿No lo recibiste? Revisa la carpeta de spam o inténtalo de nuevo en unos minutos.",
      "backToLogin": "Volver al inicio de sesión"
    },
    "title": "Magic Link",
    "subtitle": "Ingresa tu email y recibe un enlace de acceso seguro",
    "emailLabel": "Email",
    "emailPlaceholder": "tu@email.com",
    "sending": "Enviando...",
    "submit": "Enviar enlace mágico",
    "back": "Volver"
  },
  "socialButton": {
    "connecting": "Conectando...",
    "continueWith": "Continuar con {{provider}}"
  },
  "socialButtons": {
    "divider": {
      "login": "o entra con",
      "register": "o regístrate con"
    },
    "withProvider": {
      "login": "Entrar con {{provider}}",
      "register": "Registrarse con {{provider}}"
    },
    "magicLink": "Enlace mágico por email",
    "privacy": {
      "register": "Al registrarte con redes sociales, aceptas que podamos acceder a la información básica de tu perfil.",
      "login": "Tus datos están protegidos y no los compartimos con terceros."
    }
  },
  "social": {
    "errors": {
      "connect": "Error al conectar con {{provider}}",
      "login": "Error al iniciar sesión con {{provider}}"
    },
    "welcomeNew": "¡Bienvenido! Tu cuenta se ha creado con {{provider}}",
    "loggedIn": "Iniciaste sesión con {{provider}}"
  },
  "setPassword": {
    "validation": {
      "minLength": "La contraseña debe tener al menos 8 caracteres",
      "complexity": "Debe contener mayúscula, minúscula y número",
      "mismatch": "Las contraseñas no coinciden"
    },
    "invalid": {
      "title": "Enlace no válido",
      "description": "El enlace de acceso no es válido o ya se ha utilizado.",
      "requestNew": "Solicitar un nuevo enlace"
    },
    "success": {
      "title": "¡Contraseña definida!",
      "description": "Tu contraseña se ha definido correctamente. Inicia sesión para acceder.",
      "goToLogin": "Ir al inicio de sesión"
    },
    "toast": {
      "success": "¡Contraseña definida correctamente!"
    },
    "errors": {
      "set": "Error al definir la contraseña. Es posible que el enlace haya expirado."
    },
    "title": "Define tu contraseña",
    "subtitle": "Elige una contraseña para acceder a tu área de miembros",
    "passwordLabel": "Contraseña",
    "passwordPlaceholder": "Mínimo 8 caracteres",
    "confirmLabel": "Confirmar contraseña",
    "confirmPlaceholder": "Repite la contraseña",
    "submitting": "Definiendo...",
    "submit": "Definir contraseña",
    "backToLogin": "Volver al inicio de sesión"
  }
}
